import React, { Children } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

const InputLabel = (props) => {
  const { children, label, className, disabled: disabledProp } = props;
  const control = Children.only(children);

  let disabled = disabledProp;
  if (typeof disabled === 'undefined' && typeof control.props.disabled !== 'undefined') {
    disabled = control.props.disabled;
  }

  let controlProps = { disabled };
  let labelProps = props;
  ['checked', 'name', 'onChange', 'value', 'inputRef'].forEach((forwardProp) => {
    if (typeof control.props[forwardProp] === 'undefined' && typeof labelProps[forwardProp] !== 'undefined') {
      controlProps[forwardProp] = labelProps[forwardProp];
    }
  });

  const classes = classNames('inline-flex align-middle', {
    'text-primary cursor-pointer': !disabled,
    'text-inactive pointer-events-none': disabled
  }, className);

  return (
    // eslint-disable-next-line jsx-a11y/label-has-associated-control
    <label className={classes}>
      {control && React.cloneElement(control, controlProps)}
      <span className="font-regular text-base leading-tight mt-2px ml-1">{label}</span>
    </label>
  );
};

InputLabel.displayName = 'InputLabel';

InputLabel.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  label: PropTypes.string,
  disabled: PropTypes.bool
};

InputLabel.defaultProps = {
  children: null,
  label: null,
  disabled: undefined,
  className: null
};

export { InputLabel };